import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Notification } from '../../api/controllers/notifications/type';

type NotificationsState = {
  notifications: Notification[];
};

const initialState: NotificationsState = {
  notifications: [],
};

export const notificationsSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<Notification[]>) => {
      state.notifications = action.payload;
    },
    addNewNotifications: (state, action: PayloadAction<Notification>) => {
      state.notifications = [action.payload, ...state.notifications];
    },
    updateNotificationList: (state, action: PayloadAction<Notification[]>) => {
      state.notifications = [...state.notifications, ...action.payload];
    },
  },
});

export const notificationsAction = notificationsSlice.actions;
export const notificationsReducer = notificationsSlice.reducer;
